import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#163e4d",
  d: "M14.985.23 7.999 5.124 1.015.23l-.86 1.229L6.636 6 .155 10.541l.86 1.228 6.986-4.894 6.984 4.894.86-1.23-6.48-4.54 6.48-4.541Z",
  "data-name": "Tracciato 711"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "close"}) } }